/**
 * Add ellipsis to too long texts. Returns true if successful, false if no workable
 * element box found;
 *
 * @param element
 * @param text
 * @param maxChars give a maximum character amount to help performance a bit
 */
function ellipsizeTextBox(element, text, maxChars) {
  maxChars = maxChars || 1000;
  const wordArray = text.substr(0, maxChars).split(' ');
  element.innerText = wordArray.join(' ');
  if (element.scrollHeight === 0 || element.offsetHeight === 0) {
    return false;
  }
  // binary testing would improve the performance quite much here
  while (wordArray.length > 0 && element.scrollHeight > element.offsetHeight) {
    wordArray.pop();
    element.innerText = wordArray.join(' ') + ' ...';
  }
  return true;
}

export {ellipsizeTextBox};



// WEBPACK FOOTER //
// ./website/assets/scripts/modules/elements.js